import { render, staticRenderFns } from "./SanityInlineImage.vue?vue&type=template&id=6d9f9636"
import script from "./SanityInlineImage.vue?vue&type=script&lang=js"
export * from "./SanityInlineImage.vue?vue&type=script&lang=js"
import style0 from "./SanityInlineImage.vue?vue&type=style&index=0&id=6d9f9636&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports